module.exports = __webpack_public_path__ + "static/img/nan-dou-liu-xing-yan-shou-deng.b4787b8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/nan-dou-liu-xing-yan-shou-deng.jpeg
// module id = cjI6
// module chunks = 1